import { Box, Button, Skeleton, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import colors from "../../../config/colors";
import { EvaluationsSnapshot } from "../store/supervisor-home-types";
import { HOME_LINKS } from "../utils/queue-navigation";
import RailCard from "./rail-card";

interface EvaluationsCardProps {
	evaluations?: EvaluationsSnapshot;
	isLoading: boolean;
}

function EvaluationsCard({ evaluations, isLoading }: EvaluationsCardProps) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleOpenEvaluations = useCallback(() => {
		navigate(HOME_LINKS.evaluations);
	}, [navigate]);

	const rows = evaluations
		? [
			{
				key: "toFill",
				label: t("supervisor-home_evaluations-to-fill"),
				value: evaluations.toFill,
			},
			{
				key: "toAck",
				label: t("supervisor-home_evaluations-to-acknowledge"),
				value: evaluations.toAck,
			},
		]
		: [];

	return (
		<RailCard title={t("supervisor-home_evaluations")}>
			{isLoading || !evaluations ? (
				<Skeleton animation='wave' height={100} />
			) : (
				<>
					{rows.map((row) => (
						<Box
							key={row.key}
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								padding: "8px 0",
							}}
						>
							<Typography sx={{ fontSize: "14px", color: colors.title }}>
								{row.label}
							</Typography>
							<Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
								{row.value}
							</Typography>
						</Box>
					))}
					<Button
						variant='outlined'
						fullWidth
						sx={{ mt: 1.5 }}
						onClick={handleOpenEvaluations}
					>
						{t("supervisor-home_open-evaluations")}
					</Button>
				</>
			)}
		</RailCard>
	);
}

export default EvaluationsCard;
